<section class="mask-curve-top bg-gray-light py-14">
  <div class="centered-with-padding flex flex-col gap-y-10">
    @if (data.title; as title) {
      <app-title [title]="title" size="h2" />
    }
    @let questions = data.questions;
    @if (questions.length > 0) {
      <ul class="flex flex-col gap-y-3">
        @for (question of data.questions; track question.url) {
          <li class="flex">
            <a
              [routerLink]="question.url"
              target="_blank"
              class="drop-shadow-custom grid w-full grid-cols-[auto_10px] items-center gap-x-5 rounded-xl bg-anis px-5 py-4 font-bold">
              <span>{{ question.label }}</span>
              <span>
                <app-svg src="assets/icons/caret-right.svg" [width]="14" [height]="12" />
              </span>
            </a>
          </li>
        }
      </ul>
    }
    @if (data.cta; as cta) {
      <app-button [label]="cta.label" [url]="cta.url" class="self-center" />
    }
  </div>
</section>
